import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import styles from '../Messages.module.scss';
import useSelectedIndex from '../../../../hooks/stateful/useSelectedIndex.ts';

const UltraPackUpsellMessage = () => {
  const { selectedSize } = useSelectedIndex();
  const t = useTranslations();

  const getUltraSizeText = () => {
    switch (selectedSize?.label) {
      case 'L':
      case '4K':
      case 'HD':
        return t('large_images_and_video');
      case 'M':
      case 'SD':
        return t('medium_images');
      case 'S':
      case 'Web':
        return t('small_images_and_video');
      default:
        return '';
    }
  };

  if (!selectedSize) {
    return null;
  }

  return (
    <div
      className={styles.messages}
      data-testid="UltraPackUpsellMessage"
    >
      <div className={styles.buyCardMessage}>
        {t('mix_and_match_with_packs')}
      </div>
      <div className={styles.parallel}>
        <div
          className={styles.messagesHeading}
          data-testid="UltraSizeText"
        >
          {getUltraSizeText()}
        </div>
      </div>
    </div>
  );
};

export default UltraPackUpsellMessage;
